import {useQueryParams} from './useQueryParams';

export function useDeleteQueryParams() {
  const queryParams = useQueryParams();

  /**
   * Returns the updated URLSearchParams object after deleting the given keys
   */
  return (...params: string[]) => {
    const updatedUrlParams = new URLSearchParams(queryParams);

    params.forEach(p => updatedUrlParams.delete(p));

    return updatedUrlParams;
  };
}
